/*
  SSS (sekme + arama), giriş/kayıt (şifre gözü, şifremi unuttum paneli), adresler (ülke/il, sil). Vanilla JS.
*/

if (!customElements.get('alv-faq')) {
  /* SSS: paneller HTML'de varsayılan görünür. JS yalnızca aktif sekmeye ait olmayan panelleri gizler.
     Eşleştirme data-tab ↔ data-alv-faq-panel kimlikleriyle (cat-N); metinden kimlik üretilmez.
     Arama sadece kullanıcı yazınca filtreler; alan boşken hiçbir soru gizlenmez. */
  class AlvFaq extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-alv-faq-panel]'));
      this.items = Array.from(this.querySelectorAll('[data-alv-faq-item]'));
      this.search = this.querySelector('[data-alv-faq-search]');
      this.empty = this.querySelector('[data-alv-faq-empty]');
      this.activeTab = this.tabs.length ? this.tabs[0].dataset.tab : null;

      this.tabs.forEach((tab) =>
        tab.addEventListener('click', () => {
          this.activeTab = tab.dataset.tab;
          if (this.search) this.search.value = '';
          this.apply();
        })
      );
      if (this.search) this.search.addEventListener('input', () => this.apply());
      this.apply();
    }

    apply() {
      const q = this.search ? this.search.value.trim().toLocaleLowerCase('tr') : '';
      const searching = q.length > 0;

      /* Sekmeler: arama açıkken hiçbiri aktif görünmez */
      this.tabs.forEach((tab) => {
        const on = !searching && tab.dataset.tab === this.activeTab;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
      });

      /* Paneller: aramada hepsi açık; değilse yalnızca aktif olmayan (sekmesi olan) paneller gizli */
      this.panels.forEach((panel) => {
        const id = panel.dataset.alvFaqPanel;
        const hasTab = this.tabs.some((tab) => tab.dataset.tab === id);
        panel.hidden = !searching && hasTab && this.activeTab !== null && id !== this.activeTab;
      });

      /* Sorular: yalnızca arama metni varsa filtrelenir */
      let shown = 0;
      this.items.forEach((item) => {
        const match = !searching || item.textContent.toLocaleLowerCase('tr').includes(q);
        item.hidden = !match;
        if (match && !item.closest('[data-alv-faq-panel]').hidden) shown += 1;
      });
      if (this.empty) this.empty.hidden = !(searching && shown === 0);
    }
  }

  customElements.define('alv-faq', AlvFaq);
}

if (!customElements.get('alv-auth')) {
  /* Giriş | Kayıt sekmeleri: iki panel de render edilir, geçiş sayfa yenilemeden.
     Şifremi unuttum: giriş paneli içinde #recover. */
  class AlvAuth extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-alv-tab]')];
      this.panels = [...this.querySelectorAll('[data-alv-panel]')];
      this.login = this.querySelector('[data-alv-login]');
      this.recover = this.querySelector('[data-alv-recover]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.alvTab, true));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const i = this.tabs.indexOf(tab);
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : this.tabs.length - 1)) % this.tabs.length];
          this.select(next.dataset.alvTab, true);
          next.focus();
        });
      });

      this.querySelectorAll('[data-alv-recover-open]').forEach((el) =>
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleRecover(true);
        })
      );
      this.querySelectorAll('[data-alv-recover-close]').forEach((el) => el.addEventListener('click', () => this.toggleRecover(false)));

      if (window.location.hash === '#register') this.select('register', false);
      if (window.location.hash === '#recover') this.toggleRecover(true);
      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#register') this.select('register', false);
        this.toggleRecover(window.location.hash === '#recover');
      });
    }

    select(name, focusFirst) {
      if (!this.tabs.length) return;
      this.tabs.forEach((tab) => {
        const on = tab.dataset.alvTab === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.alvPanel !== name;
      });
      if (name === 'login') this.toggleRecover(false);
      const tab = this.tabs.find((t) => t.dataset.alvTab === name);
      /* customers/login ↔ customers/register adresi, yenilemeden */
      if (tab && tab.dataset.url && window.location.pathname.startsWith('/account')) {
        history.replaceState(null, '', tab.dataset.url);
      }
      if (focusFirst) {
        /* Shopify form etiketi önce gizli input'lar basar — görünür ilk alan */
        const first = this.querySelector(`[data-alv-panel="${name}"] input:not([type="hidden"])`);
        if (first) first.focus({ preventScroll: true });
      }
    }

    toggleRecover(open) {
      if (!this.login || !this.recover) return;
      this.login.hidden = open;
      this.recover.hidden = !open;
      const target = open ? this.recover.querySelector('input:not([type="hidden"])') : null;
      if (target) target.focus();
      if (open && window.location.hash !== '#recover') history.replaceState(null, '', '#recover');
      if (!open && window.location.hash === '#recover') history.replaceState(null, '', window.location.pathname);
    }
  }

  customElements.define('alv-auth', AlvAuth);
}

/* Şifre gözü — her sayfada */
document.addEventListener('click', (e) => {
  const eye = e.target.closest('[data-alv-eye]');
  if (!eye) return;
  const input = eye.parentElement.querySelector('input');
  const show = input.type === 'password';
  input.type = show ? 'text' : 'password';
  eye.setAttribute('aria-pressed', String(show));
  eye.setAttribute('aria-label', show ? eye.dataset.labelHide : eye.dataset.labelShow);
});

/* Adresler: ülke → il, silme */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-alv-addresses]');
  if (!root) return;
  root.querySelectorAll('[data-alv-country-select]').forEach((select) => {
    const id = select.dataset.formId;
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(`AddressCountry_${id}`, `AddressProvince_${id}`, {
        hideElement: `AddressProvinceContainer_${id}`,
      });
    }
  });
  root.querySelectorAll('[data-alv-address-delete]').forEach((btn) =>
    btn.addEventListener('click', () => {
      if (!window.confirm(btn.dataset.confirm)) return;
      if (window.Shopify && Shopify.postLink) {
        Shopify.postLink(btn.dataset.alvAddressDelete, { parameters: { _method: 'delete' } });
      }
    })
  );
});
